import React from "react"

import {NavLayout} from "../nav"
import DocumentTitle from "./DocumentTitle"
import Analytics from "./Analytics"

export function Layout({children}) {
  return (
    <NavLayout>
      <DocumentTitle />
      <Analytics />
      {children}
    </NavLayout>
  )
}



// WEBPACK FOOTER //
// ./src/app/Layout.js